module.exports = __webpack_public_path__ + "html/emissions.component.html";